export enum InterventionTaskStatusEnum {
  NeedsPerformed = 1,
  Performed = 3,
  DidNotPerform = 4,
  CancelledByWorkflow = 5
}

export const InterventionTaskStatusOptions = [
{ id: 1, label: 'Needs Performed' },
{ id: 3, label: 'Performed' },
{ id: 4, label: 'Did Not Perform' },
{ id: 5, label: 'Cancelled By Workflow' }
];
